// @ts-ignore - TipTap v2 types may not be fully compatible
import { Mark, mergeAttributes } from '@tiptap/core';

export const Color = Mark.create({
  name: 'textStyle',
  priority: 1000,
  inclusive: true,

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span[style]',
        getAttrs: (node: any) => {
          const element = node as HTMLElement;
          const color = element.style.color || null;
          return color ? { color } : null;
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }: any) {
    return ['span', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },

  addAttributes() {
    return {
      color: {
        default: null,
        parseHTML: (element: any) => {
          const color = (element as HTMLElement).style.color;
          return color || null;
        },
        renderHTML: (attributes: any) => {
          if (!attributes.color) {
            return {};
          }
          return {
            style: `color: ${attributes.color}`,
          };
        },
      },
    };
  },
});

